import { NgModule } from '@angular/core';
import { SubscriptionGuardDialogComponent } from './subscription-guard-dialog.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { MatDialogClose } from '@angular/material/dialog';

@NgModule({
  declarations: [SubscriptionGuardDialogComponent],
  exports: [SubscriptionGuardDialogComponent],
  imports: [
    CommonModule,
    TranslateModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    RouterModule,
    MatDialogClose,
  ],
})
export class SubscriptionGuardDialogModule {}
